<template>
  <button
      :id="stepId"
      @click="$emit('go-to-step', index)"
      data-dusk="step-icon"
      class="btn-transparent flex-row gap-xs step-icon-button"
  >
    <span class="icon transition-fast">{{ stepNumber }}</span>
    <small data-dusk="step-title">
      {{ stepTitle }}
    </small>
  </button>
</template>

<script>
export default {
  name: 'StepIcon.vue',
  emits: ['go-to-step'],
  props: {
    index: {
      type: [Number, String],
      required: true,
    },
    indexNumber: {
      type: Number,
      required: true,
    },
    step: {
      required: true,
      validator (value) {
        if (value instanceof HTMLElement) return true
        if (value instanceof Object && value.title !== undefined) return true
        return false
      }
    },
  },
  computed: {
    stepId() {
      if (this.step instanceof HTMLElement) {
        return this.step.getAttribute('step-id')
      }
      return this.step?.id
    },
    stepTitle () {
      if (this.step instanceof HTMLElement) {
        return this.step.getAttribute('title')
      }

      return this.step.title
    },
    stepNumber () {
      if (typeof this.index === 'number') {
        return this.index + 1
      }

      return this.indexNumber
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

button {
  align-items: center;
  display: flex;

  .icon {
    border-radius: 9999px;
    height: 30px;
    width: 30px;
    aspect-ratio: 1/1;
    background-color: $main-content-bg-color;
    color: $brand-primary;
    display: flex;
    align-items: center;
    place-content: center;
    font-weight: 500;
  }
}

button.active {
  .icon {
    background-color: $brand-primary;
    color: white;
  }
}

small {
  font-size: $font-size-base;
  color: $brand-primary;
  font-weight: 500;
}

</style>
